module Meevo.Plugins.AdpIntegration {
    
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class EmployeeSection extends Meevo.Components.CommonClasses.CommonSectionBase {
   
        protected busyService: Components.Busy.IBusyService;
        protected rootScope: ng.IRootScopeService;
        
        protected appSettings: Meevo.Components.Common.IAppSettings;
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            busyService: Components.Busy.IBusyService,
            $rootScope: ng.IRootScopeService,
            appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                sectionSecurityKey);
            this.busyService = busyService;
            this.rootScope = $rootScope;
            this.appSettings = appSettings;
        }

        activate(): void {
            super.activate();
          }

        changedEmployeeMapping(itemEmp: Model.AdpMeevoEmployee) {
            let params = {};
            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/Employee/`;
            let empDetail = {};
            
            if (Model.Guard.isNothing(this.model.excludeEmployeeList)) {
                this.model.excludeEmployeeList = [];
            }
            if (Model.Guard.isNothing(itemEmp.meevoEmployee) ) {
                this.model.excludeEmployeeList = _.filter(this.model.excludeEmployeeList, function (item: any) {
                    console.log(item);
                    return item.id !== itemEmp.employee_User_TId;
                });
              }
            if ( Model.Guard.isSomething(itemEmp.meevoEmployee)) {
                this.busyService.start();
                this.dataService.customMethodData(uri + itemEmp.meevoEmployee.id, "GET","")
                    .then((data: any) => {
                        itemEmp.meevoEmployee = <Model.Employee>(data.data);
                    }).finally(() => { this.busyService.stop(); });
                itemEmp.aDPLastDateUpdated = moment().format();                
                itemEmp.employee_User_TId = itemEmp.meevoEmployee.id;
                var excDataDetail: Model.DataDetail = {
                    id: itemEmp.meevoEmployee.id,
                    displayName: itemEmp.meevoEmployee.displayName
                };
                this.model.excludeEmployeeList.push(excDataDetail);
            }
        }

        updateAdpWorker(): void {
            this.busyService.start();
            this.model = this.dataService.getSection(this.baseEndpoint, "refreshEmployee")
                .then((data: any) => {
                    this.model = data;
                    
                }).finally(() => { this.busyService.stop(); });
            }

        openEmployeeProfile(employeeId: any): void {
            const endpoint = this.appSettings.ROUTE_NAMES.employee;
            const stateParams = {
                targetState: Model.MaintenanceFormVisualState.Detail,
                actionState: Model.MaintenanceFormState.Editing,
                id: employeeId
            };
            this.goToState(endpoint, stateParams);

        }

        goToState(stateName, stateParams) {
            this.rootScope.$broadcast('gotoState',
                {
                    stateName: stateName,
                    stateParams: stateParams
                });
        }


        preSave(): void {

            var model = this.model as Model.AdpMeevoEmployees;
            model.adpMeevoEmployeeList = _.filter(model.adpMeevoEmployeeList, function (item: Model.AdpMeevoEmployee) {
                item.employee_User_TId = Model.Guard.isSomething(item.meevoEmployee) ? item.meevoEmployee.id: null;
                return Meevo.Model.Guard.isSomething(item.meevoEmployee);
            });
            this.model = model;
            super.preSave();
        }


    }
}